import React, { useState, useEffect } from "react";
import DataVisualizationChart from "../Reusablecomponents/DataVisualizationChart";
import { DataVisualizationApi } from "../api";

const ChartView = ({ selectedParams, cultivationZoneId }) => {
    const [chartData, setChartData] = useState([]);
    useEffect(() => {
        if (!cultivationZoneId) {
            console.warn("No cultivationZoneId available.");
            return;
        }

        const fetchData = async () => {
            try {
                const result = await DataVisualizationApi.fetchParametersData(cultivationZoneId);
                setChartData(result);
            } catch (error) {
                console.error("Error loading chart data", error);
            }
        };

        fetchData();
    }, [cultivationZoneId]);
    return (
        <div>
            <DataVisualizationChart data={chartData} selected={selectedParams} />
        </div>
    );
};

export default ChartView;
